import React, { useContext, useEffect, useState } from 'react';
import '../styles/ProfilePage.css';
import '../styles/Posts.css';

import {
  AiOutlineHeart,
  AiTwotoneHeart
} from "react-icons/ai";

import { BiCommentDetail } from "react-icons/bi";
import { FaGlobeAmericas } from "react-icons/fa";

import HomeLogo from '../components/HomeLogo';
import Navbar from '../components/Navbar';

import {
  AuthenticationContext
} from '../context/AuthenticationContextProvider';

import {
  GeneralContext
} from '../context/GeneralContextProvider';

import { useParams } from 'react-router-dom';
import axios from 'axios';


const Profile = () => {

  const { logout } = useContext(AuthenticationContext);
  const { socket } = useContext(GeneralContext);

  const { id } = useParams();

  const userId = localStorage.getItem("userId");


  // =========================
  // PROFILE STATES
  // =========================

  const [userProfile, setUserProfile] = useState({});

  const [updateProfilePic, setUpdateProfilePic] =
    useState('');

  const [updateProfileUsername, setUpdateProfileUsername] =
    useState('');

  const [updateProfileAbout, setUpdateProfileAbout] =
    useState('');

  const [isUpdating, setIsUpdating] =
    useState(false);


  // =========================
  // FETCH PROFILE USING SOCKET
  // =========================

  useEffect(() => {

    const handleProfileFetched = ({ profile }) => {

      if (!profile) return;

      setUserProfile(profile);

      setUpdateProfilePic(profile.profilePic);

      setUpdateProfileUsername(profile.username);

      setUpdateProfileAbout(profile.about);
    };


    socket.on(
      'profile-fetched',
      handleProfileFetched
    );


    socket.emit(
      'fetch-profile',
      {
        _id: id
      }
    );


    return () => {

      socket.off(
        'profile-fetched',
        handleProfileFetched
      );

    };

  }, [socket, id]);


  // =========================
  // UPDATE PROFILE
  // =========================

  const handleUpdate = () => {

    socket.emit(
      'updateProfile',
      {
        userId: userProfile._id,
        profilePic: updateProfilePic,
        username: updateProfileUsername,
        about: updateProfileAbout
      }
    );

    setIsUpdating(false);
  };


  // =========================
  // POSTS STATE
  // =========================

  const [posts, setPosts] = useState([]);


  // =========================
  // FETCH ALL POSTS
  // =========================

  const fetchPosts = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/fetchAllPosts`
      );

      setPosts(response.data);

    } catch (error) {

      console.error(
        "Error fetching posts:",
        error
      );

    }
  };


  // =========================
  // INITIAL POSTS FETCH
  // =========================

  useEffect(() => {

    fetchPosts();

  }, []);


  // =========================
  // REAL-TIME LIKE & COMMENT
  // =========================

  useEffect(() => {

    const handleLikeUpdated = ({ post }) => {

      if (!post) return;

      setPosts((prevPosts) =>
        prevPosts.map((existingPost) =>
          existingPost._id === post._id
            ? post
            : existingPost
        )
      );
    };


    const handleCommentUpdated = ({ post }) => {

      if (!post) return;

      setPosts((prevPosts) =>
        prevPosts.map((existingPost) =>
          existingPost._id === post._id
            ? post
            : existingPost
        )
      );
    };


    socket.on(
      "likeUpdated",
      handleLikeUpdated
    );

    socket.on(
      "commentUpdated",
      handleCommentUpdated
    );


    return () => {

      socket.off(
        "likeUpdated",
        handleLikeUpdated
      );

      socket.off(
        "commentUpdated",
        handleCommentUpdated
      );

    };

  }, [socket]);


  // =========================
  // LIKE POST
  // =========================

  const handleLike = (userId, postId) => {

    socket.emit(
      'postLiked',
      {
        userId,
        postId
      }
    );

  };


  // =========================
  // UNLIKE POST
  // =========================

  const handleUnLike = (userId, postId) => {

    socket.emit(
      'postUnLiked',
      {
        userId,
        postId
      }
    );

  };


  // =========================
  // FOLLOW USER
  // =========================

  const handleFollow = (userId) => {

    socket.emit(
      'followUser',
      {
        ownId: localStorage.getItem('userId'),
        followingUserId: userId
      }
    );

  };


  // =========================
  // UNFOLLOW USER
  // =========================

  const handleUnFollow = (userId) => {

    socket.emit(
      'unFollowUser',
      {
        ownId: localStorage.getItem('userId'),
        followingUserId: userId
      }
    );

  };


  // =========================
  // FOLLOW / UNFOLLOW UPDATES
  // =========================

  useEffect(() => {

    const handleUserFollowed = ({ following }) => {

      localStorage.setItem(
        'following',
        following
      );

    };


    const handleUserUnFollowed = ({ following }) => {

      localStorage.setItem(
        'following',
        following
      );

    };


    socket.on(
      'userFollowed',
      handleUserFollowed
    );

    socket.on(
      'userUnFollowed',
      handleUserUnFollowed
    );


    return () => {

      socket.off(
        'userFollowed',
        handleUserFollowed
      );

      socket.off(
        'userUnFollowed',
        handleUserUnFollowed
      );

    };

  }, [socket]);


  // =========================
  // COMMENTS
  // =========================

  const [comment, setComment] =
    useState('');


  const handleComment = (
    postId,
    username
  ) => {

    if (!comment.trim()) return;

    socket.emit(
      'makeComment',
      {
        postId,
        username,
        comment: comment.trim()
      }
    );

    setComment('');
  };


  // =========================
  // DELETE POST
  // =========================

  const handleDeletePost = (postId) => {

    socket.emit(
      'delete-post',
      {
        postId
      }
    );

  };


  // =========================
  // REAL-TIME DELETE UPDATE
  // =========================

  useEffect(() => {

    const handlePostDeleted = ({ posts }) => {

      if (posts) {
        setPosts(posts);
      }

    };


    socket.on(
      'post-deleted',
      handlePostDeleted
    );


    return () => {

      socket.off(
        'post-deleted',
        handlePostDeleted
      );

    };

  }, [socket]);


  return (

    <div className='profilePage'>

      <HomeLogo />

      <Navbar />


      {/* =========================
          PROFILE CARD
      ========================= */}

      <div
        className="profileCard"
        style={
          isUpdating
            ? { display: 'none' }
            : { display: "flex" }
        }
      >

        <img
          src={userProfile.profilePic}
          alt=""
        />

        <h4>
          {userProfile.username}
        </h4>

        <p>
          {userProfile.about}
        </p>


        <div className="profileDetailCounts">

          <div className="followersCount">

            <p>Followers</p>

            <p>
              {userProfile.followers
                ? userProfile.followers.length
                : 0}
            </p>

          </div>


          <div className="followingCounts">

            <p>Following</p>

            <p>
              {userProfile.following
                ? userProfile.following.length
                : 0}
            </p>

          </div>

        </div>


        <div className="profileControls">

          {
            userProfile._id === userId ?

              <div className="profileControlBtns">

                <button
                  onClick={async () => {
                    await logout();
                  }}
                >
                  Logout
                </button>


                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    setIsUpdating(true)
                  }
                >
                  Edit
                </button>

              </div>

              :

              <div className="profileControlBtns">

                {
                  (localStorage.getItem('following') || '')
                    .includes(userProfile._id) ?

                    <>

                      <button
                        onClick={() =>
                          handleUnFollow(
                            userProfile._id
                          )
                        }
                        style={{
                          backgroundColor:
                            'rgb(224, 42, 42)'
                        }}
                      >
                        Unfollow
                      </button>


                      <button>
                        Message
                      </button>

                    </>

                    :

                    <button
                      onClick={() =>
                        handleFollow(
                          userProfile._id
                        )
                      }
                    >
                      Follow
                    </button>
                }

              </div>
          }

        </div>

      </div>


      {/* =========================
          EDIT PROFILE
      ========================= */}

      <div
        className='profileEditCard'
        style={
          !isUpdating
            ? { display: 'none' }
            : { display: "flex" }
        }
      >

        <div className="mb-3">

          <label
            htmlFor="profileImage"
            className="form-label"
          >
            Profile Image
          </label>

          <input
            type="text"
            className="form-control"
            id="profileImage"
            onChange={(e) =>
              setUpdateProfilePic(
                e.target.value
              )
            }
            value={updateProfilePic}
          />

        </div>


        <div className="mb-3">

          <label
            htmlFor="profileUsername"
            className="form-label"
          >
            Username
          </label>

          <input
            type="text"
            className="form-control"
            id="profileUsername"
            onChange={(e) =>
              setUpdateProfileUsername(
                e.target.value
              )
            }
            value={updateProfileUsername}
          />

        </div>


        <div className="mb-3">

          <label
            htmlFor="editAbout"
            className="form-label"
          >
            About
          </label>

          <input
            type="text"
            className="form-control"
            id="editAbout"
            onChange={(e) =>
              setUpdateProfileAbout(
                e.target.value
              )
            }
            value={updateProfileAbout}
          />

        </div>


        <button
          className='btn btn-primary'
          onClick={handleUpdate}
        >
          Update
        </button>

      </div>


      {/* =========================
          PROFILE POSTS
      ========================= */}

      <div className="profilePostsContainer">

        {
          posts
            .filter(
              post =>
                post.userId === userProfile._id
            )
            .map((post) => (

              <div
                className="Post"
                key={post._id}
              >

                <div className="postTop">

                  <div className="postTopDetails">

                    <img
                      src={post.userPic}
                      alt=""
                      className="userpic"
                    />

                    <h3 className="usernameTop">
                      {post.userName}
                    </h3>

                  </div>


                  {/* Only show delete button for own post */}

                  {post.userId === userId && (

                    <button
                      className='btn btn-danger deletePost'
                      onClick={() =>
                        handleDeletePost(
                          post._id
                        )
                      }
                    >
                      Delete
                    </button>

                  )}

                </div>


                {/* PHOTO / VIDEO */}

                {
                  post.fileType === 'photo'

                    ?

                    <img
                      src={post.file}
                      className='postimg'
                      alt=""
                    />

                    :

                    <video
                      id="videoPlayer"
                      className='postimg'
                      controls
                      autoPlay
                      muted
                    >

                      <source
                        src={post.file}
                      />

                    </video>
                }


                {/* =========================
                    POST REACTIONS
                ========================= */}

                <div className="postReact">

                  <div className="supliconcol">

                    {
                      post.likes.includes(userId)

                        ?

                        <AiTwotoneHeart
                          className='support reactbtn'
                          onClick={() =>
                            handleUnLike(
                              userId,
                              post._id
                            )
                          }
                        />

                        :

                        <AiOutlineHeart
                          className='support reactbtn'
                          onClick={() =>
                            handleLike(
                              userId,
                              post._id
                            )
                          }
                        />
                    }


                    <label
                      className='supportCount'
                    >
                      {post.likes.length}
                    </label>

                  </div>


                  <BiCommentDetail
                    className='comment reactbtn'
                  />


                  <div className="placeiconcol">

                    <FaGlobeAmericas
                      className='placeicon reactbtn'
                    />

                    <label className='place'>
                      {post.location}
                    </label>

                  </div>

                </div>


                {/* DESCRIPTION */}

                <div className="detail">

                  <div className='descdataWithBtn'>

                    <label className="desc labeldata">

                      <span
                        style={{
                          fontWeight: 'bold'
                        }}
                      >
                        {post.userName}
                      </span>

                      &nbsp;
                      {post.description}

                    </label>

                  </div>

                </div>


                {/* =========================
                    COMMENTS
                ========================= */}

                <div className="commentsContainer">

                  <div className="makeComment">

                    <input
                      type="text"
                      placeholder='type something...'
                      value={comment}
                      onChange={(e) =>
                        setComment(
                          e.target.value
                        )
                      }
                    />


                    {
                      comment.length === 0

                        ?

                        <button
                          className='btn btn-primary'
                          disabled
                        >
                          comment
                        </button>

                        :

                        <button
                          className='btn btn-primary'
                          onClick={() =>
                            handleComment(
                              post._id,
                              localStorage.getItem(
                                'username'
                              )
                            )
                          }
                        >
                          comment
                        </button>
                    }

                  </div>


                  <div className="commentsBody">

                    <div className="comments">

                      {
                        post.comments.map(
                          (comment, index) => (

                            <p
                              key={`${post._id}-${index}`}
                            >

                              <b>
                                {comment[0]}
                              </b>

                              {' '}
                              {comment[1]}

                            </p>

                          )
                        )
                      }

                    </div>

                  </div>

                </div>

              </div>

            ))
        }

      </div>

    </div>
  );
};


export default Profile;
